<template>
  <ai-carousel-full-width
    access-id="HotelSpaActivitiesCarousel"
    :items="items"
    :component="AiSpaActivityCard"
    :aria-label="$t('accessibility.description.hotelSpaActivitiesCarousel')"
    :title="$t('hotel.spaActivities.title')"
    :description="description"
    button-position="center"
    mobile-button
    class="HotelSpaActivities" />
</template>

<script setup lang="ts">
import type { HotelSpaActivity } from '~~/domains/graphql';
import AiSpaActivityCard from '~~/domains/ux/molecules/AiSpaActivityCard/AiSpaActivityCard.vue';

export interface HotelSpaActivitiesProps {
  spaActivities: HotelSpaActivity[];
  description: string;
}

const items = computed(() => {
  return props.spaActivities.map(spaActivity => {
    return {
      component: AiSpaActivityCard,
      key: spaActivity.id,
      props: {
        description: spaActivity.description ?? '',
        picture: spaActivity.picture,
        title: spaActivity.title,
        menuUrl: spaActivity.menuUrl,
      },
    };
  });
});

const props = withDefaults(defineProps<HotelSpaActivitiesProps>(), {
  spaActivities: () => [],
});
</script>

<style lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';

#HotelSpaActivitiesCarousel > li.AiCarousel-slide.AiCarousel-slide {
  align-items: flex-start;
  @media (mq.$from-medium) {
    align-items: center;
  }
}
</style>
